import { render, staticRenderFns } from "./IQControlledOverlayHeader.vue?vue&type=template&id=17c22d97&scoped=true"
import script from "./IQControlledOverlayHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./IQControlledOverlayHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQControlledOverlayHeader.vue?vue&type=style&index=0&id=17c22d97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c22d97",
  null
  
)

export default component.exports